export const projectTypes = ['Cerrado', 'Tiempos y Materiales', 'Interno'];
